import React from "react";
import { DgaButton, DgaQuote, DgaCard, DgaLoading, DgaCardV2, DgaCardContent, DgaCardTitle } from "platformscode-new-react";
const ameen     = "assets2/imges/ameen_old.png";  // PNG fallback for non-WebP browsers
const ameenWebp = "assets2/imges/ameen.webp";
import { useState, useEffect } from "react";


function Quote({ text, author }) {

  const sectionsData = [
    {
      cardWidth: "250px",
      quote: {
        authorDescription: "معالي أمين العاصمة المقدسة",
        authorName: "الأستاذ مساعد بن عبدالعزيز الداود",
        quoteDescription: `

        في مكة المكرمة، حيث تتجلّى الرسالة وتسمو المسؤولية، نعمل في أمانة العاصمة المقدسة على أداء واجبنا بأعلى درجات الإخلاص والطموح، مستشعرين قدسية المكان وعِظم الأمانة الملقاة على عاتقنا، ومؤمنين بأن خدمة هذه المدينة المباركة شرفٌ لا يعلوه شرف.
        
        نستمد رؤيتنا من مستهدفات رؤية المملكة 2030 التي وضعت الإنسان والمكان في قلب التنمية، ونعمل على تحويل الطموحات الكبرى إلى واقع حي ينعكس على حياة السكان والزوار، ويجسّد روح المدينة، ويحفظ هويتها، ويعزز مكانتها محليًا وعالميًا.
        
        
        `,
        quoteTitle: "كلمة معالي أمين العاصمة المقدسة",
      },
      imageSrc: ameen,
      imageSrcWebp: ameenWebp,
      imageAlt: "صورة معالي أمين العاصمة المقدسة",
    },
  ];

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // adjust breakpoint as needed
    };

    handleResize(); // Set initial value
    window.addEventListener("resize", handleResize, { passive: true });
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (

    <>

      <section className="cw-full !pt-[80px] !pb-[80px]" data-aos="fade-in" data-aos-anchor-placement="top-center" style={{ justifyItems: "center" }}>
        {sectionsData.map(({ quote, imageSrc, imageSrcWebp, imageAlt }, index) => (
          <DgaCardV2 key={index} effect="none" width="250px" onClick={() => (window.location.href = "/about-administrator")}
          >
            <DgaCardContent>
              <div className="items-end grid grid-cols-1 md:grid-cols-12 gap-4">
                <div className="order-1 md:order-2  md:col-span-8  sm:col-span-12 lg:col-span-9 p-4">

                  <div className="!mt-[32px]" data-aos="fade-in"
                    data-aos-delay="200"
                  >

                    <DgaQuote
                      authorDescription={quote.authorDescription}
                      authorName={quote.authorName}
                      showAvatar={false}
                      quoteDescription={quote.quoteDescription}
                      quoteTitle={quote.quoteTitle}
                      showQuoteDescription={!isMobile}

                    />
                  </div>

                  <div className="hidden md:block  text-center md:text-left">
                    <DgaButton
                      className="!p-[20px]"
                      label="اقرأ المزيد"
                      size="lg"
                      variant="primary-brand"
                      onClick={() => (window.location.href = "/about-administrator")}

                    />
                  </div>
                </div>

                <div className="order-2 md:order-1 md:col-span-4 lg:col-span-3 sm:col-span-12 p-4 self-start ">
                  <picture>
                    {imageSrcWebp && <source srcSet={imageSrcWebp} type="image/webp" />}
                    <img
                      className="w-full h-[400px] object-cover !object-[0%_0%] rounded-md"
                      data-aos="fade-left"
                      data-aos-delay="100"
                      src={imageSrc}
                      alt={imageAlt}
                      width="400"
                      height="601"
                      loading="lazy"
                      decoding="async"
                      sizes="(max-width: 768px) 100vw, 33vw"
                    />
                  </picture>

                  <div className="w-full  block md:hidden text-center !mt-[14px]">
                    <DgaButton
                      className="!p-[20px]  "
                      label="اقرأ المزيد"
                      size="lg"
                      variant="primary-brand"
                      onClick={() => (window.location.href = "/about-administrator")}

                    />
                  </div>
                </div>

              </div>
            </DgaCardContent>
          </DgaCardV2>
        ))}
      </section>

    </>
  );
}

export default Quote;
